import getExtensionFromFileName from './getExtensionFromFileName';

const imageFileExtensions: string[] = [
    '.bmp',
    '.gif',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.jfif',
    '.dib',
    '.png',
    '.psd',
    '.tiff',
    '.tif',
];

export default function isImageFile(fileName: string): boolean {
    const extension: string = getExtensionFromFileName(fileName);
    if (extension) {
        return imageFileExtensions.indexOf(extension.toLowerCase()) >= 0;
    }

    return false;
}
